import { render } from "./ProjectTable.vue?vue&type=template&id=1771d68f&scoped=true&ts=true"
import script from "./ProjectTable.ts?vue&type=script&lang=ts"
export * from "./ProjectTable.ts?vue&type=script&lang=ts"

import "./ProjectTable.scss?vue&type=style&index=0&id=1771d68f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1771d68f"]])

export default __exports__